import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import _ from 'lodash';

import { makeCanonicalTagObj, makeHreflangTagArr } from '@/utils';
import BreadCrumbMenu from '@/components/BreadCrumbMenus/';
import Placeholder from '@/components/Placeholder';
import { TABLET_P } from '@/constants';
import TreatmentOverview from './TreatmentOverview';
import TreatmentProcess from './TreatmentProcess';
import ReleatedTreatments from './ReleatedTreatments';
import ProductRecommendation from '../../components/ProductRecommendation/ProductRecommendation';

const TreatmentPage = ({ copy, data, locale, menuInfo }) => (
  <React.Fragment>
    {_.get(data, 'slug') && (
      <Helmet
        link={[
          makeCanonicalTagObj(locale, `/treatment/${data.slug}`),
          ...makeHreflangTagArr(data.region, `/treatment/${data.slug}`)
        ]}
      />
    )}
    <React.Fragment>
      <TreatmentOverview name={data.name} description={data.description} duration={data.duration} />
      {data.procedure && <TreatmentProcess steps={data.procedure} cImages={data.comparedImages}/>}
      {data.relatedTreatments && <ReleatedTreatments treatments={data.relatedTreatments} />}
      {data.featuredProducts && <ProductRecommendation copy={copy} relatedProducts={data.featuredProducts} />}
    </React.Fragment>
    {!(
      data &&
      _.get(data, 'name') &&
      locale &&
      menuInfo &&
      _.get(menuInfo, 'label') &&
      _.get(menuInfo, 'children')
    ) ? (
      <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
    ) : (
      <BreadCrumbMenu
        currentPath={window.location.href}
        items={[
          {
            name: 'TOP',
            path: `/${locale}/`,
          },
          // メニュー名を設定する (PRODUCTS)
          {
            name: menuInfo.label,
            path: null,
          },
          // カテゴリ名を設定する (HAIR CARE)
          {
            name: menuInfo.children[0].label.toUpperCase(),
            path: null,
          },
          // サブカテゴリ名を設定する (SUBLIMIC)
          {
            name: menuInfo.children[0].children[0].label.toUpperCase(),
            path: `/${locale}${menuInfo.children[0].children[0].url}`,
          },
          // タイトルを設定する
          {
            name: data.name.toUpperCase(),
            path: null,
          },
        ]}
      />
    )}
  </React.Fragment>
);

TreatmentPage.defaultProps = {
  copy: {},
  data: {
    procedure: [{ key: 1 }, { key: 2 }, { key: 3 }],
    relatedTreatments: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }],
    featuredProducts: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }],
    comparedImages: undefined,
  },
};

TreatmentPage.propTypes = {
  locale: PropTypes.string.isRequired,
  // 商品情報 (パンくずリストに必要な情報を含む)
  menuInfo: PropTypes.shape({}).isRequired,
  copy: PropTypes.shape(),
  data: PropTypes.shape(),
};

const mapState = state => ({
  locale: state.locale,
  // 商品情報をキャッシュしておく
  menuInfo: state.siteOptions.menu ? state.siteOptions.menu[3] : {},
  copy: state.siteOptions.siteCopyTreatmentPage,
});

export default connect(mapState)(TreatmentPage);



// WEBPACK FOOTER //
// ./src/pages/TreatmentPage/TreatmentPage.js